import { useDrawer } from '@cast/design-system';
import { DateRange } from '@cast/shared-types';

import { WorkloadDetailsRouteProps } from 'features/cluster/cost-report/workloads/_types';

import { DestinationsHistoryDrawer } from './_components/DestinationsHistoryDrawer';

export const useWorkloadTrafficDestinationsHistoryDrawer = () => {
  const { open } = useDrawer();

  const _open = (
    props: WorkloadDetailsRouteProps & {
      range: DateRange;
      adjustedRange: DateRange;
      timezone: string;
    }
  ) => {
    open({ component: DestinationsHistoryDrawer, props });
  };

  return { open: _open };
};
